import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./AccumulatorOverrideScheduleFormConfig";
const {
  ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
  ACCUMULATOR_OVERRIDE_SCHEDULE,
  ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE,
  EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE
} = ROUTE_PATHS;

const AccumulatorOverrideScheduleForm = ({ mode }) => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();
  // const { selectedPriceSchedules = [],
  //   previousScreen = '/accumulator-overrride-schedule',
  //   currentIndex: initialIndex = 0,
  //   rowData} = location.state || {};

  /* const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedSchedules = [],
    previousScreen = ACCUMULATOR_OVERRIDE_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  */
  const [stateVal, setStateVal] = useState(location.state || []);
  const { previousState, currentState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    //console.log("current state in form", currentState, previousState);

    return { previousState, currentState };
  }, [stateVal]);
  const {
    selectedSchedules,
    previousScreen,
    initialIndex,
    initialExternalMode,
    initialLookupType
  } = useMemo(() => {
    let {
      selectedSchedules = [],
      previousScreen = ACCUMULATOR_OVERRIDE_SCHEDULE,
      currentIndex: initialIndex = 0,
      lookupType: initialLookupType,
      externalMode: initialExternalMode = false
    } = currentState;
    return {
      selectedSchedules,
      previousScreen,
      initialIndex,
      initialExternalMode,
      initialLookupType
    };
  }, [currentState]);
  console.log("current state", currentState);
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const toast = useToast();

  const lastScheduleName = initialFormData?.aosAccumOvrdSchedule || "";
  const updatedParamsData = {
    ...currentState.paramsData,
    aosAccumOvrdSchedule: lastScheduleName,
    hiddenRecordIndicator: "Active"
  };

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState]
        }
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setInitialFormData({});
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, [
        ...previousState,
        {
          paramsData: {...updatedParamsData,aosAccumOvrdScdeType:""},
          currentIndex: currentIndex
        }
      ]);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";

    if (isAddMode(currentMode)) {
      url = "api/aosaccumulatorovrdscde";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/aosaccumulatorovrdscde";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];
    }

    if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {
      toast.current.show({
        severity: "info",
        summary: "",
        detail: "No Change of Information",
        life: 3000
      });
      return;
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000
      });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);

        var paramsData = {
          aosAccumOvrdSchedule: responseData.aosAccumOvrdSchedule,
          aosAccumOvrdScdeType: responseData.aosAccumOvrdScdeType
        };

        const latestCurrentState = {
          ...currentState,
          selectedSchedules: [{ ...responseData }],
          paramsData,
          currentIndex: 0
        };
        setStateVal([...previousState, latestCurrentState]);
        navigateToPage(EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE, [
          ...previousState,
          latestCurrentState
        ]);
      }
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message }
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      //keyFunc.Enter = submitForm;
      keyName.chmod = "View";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.F7 = "Criteria";
      keyFunc.F7 = () => {
        navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSchedules: [selectedSchedules[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0
          }
        ]);
      };
      keyName.F14 = "Note";
      keyFunc.F14 = () => {
        navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedPriceSchedules: [selectedSchedules[currentIndex]],
            previousScreen: location.pathname
            // description:initialFormData.bscDescription
          }
        ]);
      };
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyName.F7 = "Criteria";
      keyFunc.F7 = () => {
        navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSchedules: [selectedSchedules[currentIndex]],
            previousScreen: location.pathname,
            currentIndex: 0
          }
        ]);
      };
      keyName.F14 = "Note";
      keyFunc.F14 = () => {
        navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_NOTE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedPriceSchedules: [selectedSchedules[currentIndex]],
            previousScreen: location.pathname
            // description:initialFormData.bscDescription
          }
        ]);
      };
    }

    return [keyFunc, keyName];
  }, [
    currentMode,
    currentIndex,
    initialFormData,
    currentState,
    previousState,
    externalMode
  ]);

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setExternalMode(initialExternalMode);
  }, [initialExternalMode]);

  useEffect(() => {
    const fetchInitialData = async () => {
      console.log("rowData -> ", selectedSchedules[currentIndex]);
      const url = isAddMode(currentMode)
        ? `api/aosaccumulatorovrdscde/initial-form-data`
        : `api/aosaccumulatorovrdscde/${encodeURIComponent(
            selectedSchedules[currentIndex]?.aosAccumOvrdSchedule
          )}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };
    if (
      (isAddMode(currentMode) || selectedSchedules.length) &&
      !Object.keys(initialFormData).length
    )
      fetchInitialData();
  }, [mode, currentIndex, selectedSchedules]);

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default AccumulatorOverrideScheduleForm;

const screenInfo = {
  ADD: ["Add Accumulator Override Schedule", "RCAOS002"],
  CHANGE: ["Accumulator Override Schedule Detail", "RCAOS004"],
  VIEW: ["Accumulator Override Schedule Detail", "RCACM004"]
};
